<template>
 <v-card :class="{ 'mt-4': !company.premium_freigeschaltet }" color="transparent" :flat="company.premium_freigeschaltet === 1">
 
      <v-toolbar
        class="mt-4"
        flat
      >
        <v-toolbar-title>Offene Stellenanzeigen</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-title class="text-xs-right">Bewerbungsfrist</v-toolbar-title>
      </v-toolbar>
     <stellen-liste-betriebsprofil
        :stellen="company.stellen"
        v-if="company.stellen.length > 0"
        key="company"
     ></stellen-liste-betriebsprofil>
 </v-card>
</template>


<script>
// import { mapGetters } from 'vuex'
import StellenListeBetriebsprofil from '~/components/stellen/StellenListeBetriebsprofil.vue'

export default {
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  components: {
    StellenListeBetriebsprofil
  },

  data () {
    return {
      // loading: true
    }
  },
  computed: {
  },
  mounted: function () {},
  methods: {}
}
</script>

<style>
</style>